import { Input } from '@/components/common/Input'
import { Textarea } from '@/components/common/Textarea'
import { CheckboxGroup } from '@/components/common/CheckboxGroup'
import { StepShell, StepGrid } from '../StepShell'
import { PAIN_TYPE_OPTIONS, SWELLING_FEVER_OPTIONS } from '@/lib/constants'

const DEFAULT = {
  duration: '',
  type_of_pain: [],
  aggravating_factors: '',
  relieving_factors: '',
  previous_dental_treatment: '',
  swelling_fever_pus: [],
}

export function HistoryPresentIllnessStep({ value, onChange, errors = {} }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 2 — Phase 2"
      title="History of present illness"
      description="Duration, character of pain, and aggravating / relieving factors."
    >
      <Input
        label="Duration"
        value={v.duration}
        onChange={(e) => set({ duration: e.target.value })}
        placeholder="e.g. 5 days, 2 weeks"
      />
      <CheckboxGroup
        label="Type of pain"
        options={PAIN_TYPE_OPTIONS}
        value={v.type_of_pain}
        onChange={(arr) => set({ type_of_pain: arr })}
        columns={3}
      />
      <StepGrid>
        <Textarea
          label="Aggravating factors"
          rows={2}
          value={v.aggravating_factors}
          onChange={(e) => set({ aggravating_factors: e.target.value })}
          placeholder="What makes the pain worse?"
        />
        <Textarea
          label="Relieving factors"
          rows={2}
          value={v.relieving_factors}
          onChange={(e) => set({ relieving_factors: e.target.value })}
          placeholder="What gives relief?"
        />
      </StepGrid>
      <Textarea
        label="Previous dental treatment for this complaint"
        rows={2}
        value={v.previous_dental_treatment}
        onChange={(e) => set({ previous_dental_treatment: e.target.value })}
        placeholder="Any earlier treatment attempts?"
      />
      <CheckboxGroup
        label="Associated findings"
        options={SWELLING_FEVER_OPTIONS}
        value={v.swelling_fever_pus}
        onChange={(arr) => set({ swelling_fever_pus: arr })}
        columns={3}
      />
    </StepShell>
  )
}
